
define('text!views/shared/alerts/action_alert.html',[],function () { return '\r\n<div class="action-alert-inner-container">\r\n\t\r\n\t<h2 class="js-alert-action-header"><%= this.data.alert_header %></h2>\r\n\r\n\t<div class="action-alert-content js-action-alert-content"></div>\r\n\r\n</div>';});

